import { StartFreeButton } from "../MarketingButton";
import { marketingButtonClass } from "../marketingButtonClass";
import { scrollToSection } from "../scrollToSection";

export default function OverviewHero() {
  return (
    <section className="relative min-h-[calc(100svh-72px)] overflow-hidden [background:radial-gradient(circle_at_25%_18%,rgba(62,80,255,0.5),transparent_38%),#050B2D] px-[6vw] pb-[118px] pt-[76px] text-white max-[680px]:flex max-[680px]:min-h-[calc(100svh-64px)] max-[680px]:flex-col max-[680px]:px-5 max-[680px]:pb-[52px] max-[680px]:pt-0">
      <figure
        aria-hidden
        className="pointer-events-none absolute bottom-0 right-[50px] z-[1] m-0 aspect-[1122/1402] h-[calc(100%-24px)] max-w-[56%] max-[980px]:max-w-[58%] max-[680px]:relative max-[680px]:inset-auto max-[680px]:-mx-5 max-[680px]:aspect-auto max-[680px]:h-[clamp(390px,56svh,540px)] max-[680px]:w-[calc(100%+40px)] max-[680px]:max-w-none max-[680px]:[mask-image:linear-gradient(180deg,#000_0,#000_88%,transparent_100%)]"
      >
        <img
          src="/marketing/hero-artist.webp"
          alt=""
          fetchPriority="high"
          className="block size-full origin-top-right scale-[1.09] object-contain object-[right_bottom] [mask-image:linear-gradient(180deg,#000_0,#000_80%,rgba(0,0,0,0.82)_84%,rgba(0,0,0,0.42)_88%,transparent_92.5%)] max-[680px]:scale-100 max-[680px]:object-[center_top] max-[680px]:[mask-image:none]"
        />
      </figure>

      <div className="relative z-[2] mt-[clamp(110px,18svh,170px)] w-[min(52%,760px)] -translate-y-[55px] max-[980px]:w-[56%] max-[680px]:order-1 max-[680px]:-mt-[30px] max-[680px]:w-full max-[680px]:translate-y-0">
        <p className="mb-[22px] font-permanent-marker text-[clamp(52px,6.4vw,92px)] leading-[1.1] tracking-[0.01em] text-teal-500 max-[680px]:mb-4 max-[680px]:text-[clamp(48px,13vw,58px)] max-[680px]:leading-[0.94]">
          You create.
        </p>
        <h1 className="m-0 font-figtree text-[clamp(38px,5vw,64px)] font-black uppercase leading-[0.97] tracking-[-0.055em] max-[980px]:text-[clamp(42px,5.5vw,54px)] max-[680px]:text-[clamp(32px,8.8vw,40px)]">
          <span className="block whitespace-nowrap">Lutely handles</span>
          <span className="block whitespace-nowrap">what comes</span>
          <span className="block whitespace-nowrap">next.</span>
        </h1>
        <p className="mt-[26px] max-w-[630px] font-open-sans text-[clamp(18px,1.45vw,22px)] leading-[1.55] text-white/[0.77] max-[680px]:mt-5 max-[680px]:text-[17px] max-[680px]:leading-[1.5]">
          <span className="block">
            Prepare every track, package every release,
          </span>
          <span className="block">sell directly to your fans.</span>
        </p>
        <div className="mt-[30px] flex flex-wrap items-center gap-[15px]">
          <StartFreeButton>Get started</StartFreeButton>
          <a
            href="#artists-first"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection("artists-first");
            }}
            className={marketingButtonClass("secondary")}
          >
            Learn more
          </a>
        </div>
      </div>
    </section>
  );
}
